import type { ReactNode } from 'react'
import { ActivityIndicator } from 'react-native'

import type { TGetAutocompleteData } from '@/src/features/geo/api/types.ts/getAutocomplete.types'

import { Listbox, ListboxItem } from '../../listbox'

const DOTS = '...'
const placeholders = Array.from({ length: 5 }, () => ({ placeholder: true }))

export type TLocalitiesListProps = {
  currentPlaceId?: string
  isListLoading?: boolean
  isPlaceLoading?: boolean
  items: TGetAutocompleteData['suggestions']
  onSelect: (placeId: string) => void
}

export const LocalitiesList = ({
  currentPlaceId,
  isListLoading,
  isPlaceLoading,
  items,
  onSelect,
}: TLocalitiesListProps): ReactNode => (
  <Listbox className="gap-2 py-2" items={isListLoading ? [...items, ...placeholders] : items}>
    {(item, index) => {
      if ('placePrediction' in item) {
        const { placePrediction } = item
        const isItemLoading = currentPlaceId === placePrediction.placeId && isPlaceLoading
        return (
          <ListboxItem
            key={placePrediction.placeId}
            onPress={() => onSelect(placePrediction.placeId)}
            color={isItemLoading ? 'primary' : 'default'}
            endContent={isItemLoading ? <ActivityIndicator /> : null}
          >
            {placePrediction.text.text}
          </ListboxItem>
        )
      }

      return (
        <ListboxItem key={index} disabled className="animate-pulse">
          {DOTS}
        </ListboxItem>
      )
    }}
  </Listbox>
)
